import { AbstractControl, ValidatorFn } from '@angular/forms';

export function iccdDateValidator(): ValidatorFn {
  const error = { iccdDate: true };

  return (control: AbstractControl) => {
    const regex = /^[0-9]{4}(-[0-9]{2}(-[0-9]{2})?)?$/;
    const value = control.value;

    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      return value.match(regex) ? null : error;
    } else {
      return error;
    }

  };
}

export function dateValidator(): ValidatorFn {
  const error = { itDate: true };

  return (control: AbstractControl) => {
    const itRegex = /^[0-9]{2}(\/[0-9]{2}(\/[0-9]{4})?)?$/;
    const standardDateRegex = /^[0-9]{4}(-[0-9]{2}(-[0-9]{2})?)?$/;
    const ISODateRegex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;

    const value = control.value;

    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      return value.match(itRegex) || value.match(standardDateRegex) || value.match(ISODateRegex) ? null : error;
    } else {
      return error;
    }

  };
}
